import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { init } from '@sentry/angular';
import { environment } from './environments/environment';
import './app/core/ag-grid/ag-grid-setup';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (window.location.href.includes('login/callback')) {
  const accessToken = window.location.hash.split('#access_token=')[1];
  localStorage.setItem('access_token', accessToken);
}

if (environment.production) {
  enableProdMode();
}

init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  enabled: environment.sentry.logToSentry,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
